export default {
	indomaret: {
		name: null,
		store_code: null,
		address: null,
		dc_code: null,
		lat: null,
		long: null
	},
	schedule_plan: {
		mitra_kerja: null,
		day_of_week: null,
		dc_code: null,
		store_id: null,
		flag: null,
		date_inserted: null
	},
	order: {
		order_number: null,
		employee_id: null,
		customer_id: null,
		pricing_unit_id: null,
		date_order: null,
		status: null,
		description: null,
		plan_delivery_order: null,
		order_type: null
	},
	order_detail: {
		order_id: null,
		product_id: null,
		qty_plan: null,
		price_plan: null,
		total_price_plan: null,
		qty_actual: null,
		price_actual: null,
		total_price_actual: null,
		order_type: null
	},
	spkb: {
		spkb_number: null,
		delivery_date: null,
		invoice_pic_employee: null,
		invoice_pic_dc: null,
		driver: null,
		delivery_to: null,
		send_to_dc: null,
		invoice_pic: null,
		status: null,
		notes: null,
		spkb_type: null
	},
	spkb_order: {
		order_number: null,
		spkb_number: null
	},
	customer: {
		name: null,
		customer_group: null,
		dc_code: null,
		zone: null,
		sub_zone_code: null,
		order_time_id: null,
		owner_name: null,
		address: null,
		source_delivery: null,
		route_delivery: null,
		distance_store_to_dc: null,
		mobile_phone: null,
		mobile_phone2: null,
		mobile_phone3: null,
		lat: null,
		lng: null,
		bank_account_name: null,
		bank_account_number: null,
		asset_id: null,
		contract_number: null,
		placement_date: null,
		vehicle_delivery_id: null,
		customer_code: null,
		bill_address: null,
		status: null,
		company_for_letter: null,
		province: null,
		regencies: null,
		district: null,
		villages: null,
		ktp_number: null,
   address_ktp: null 

	},
	customer_asset: {
		customer_asset_id: null,
		customer_id: null,
		asset_id: null,
		contract_number_alias: null,
		placement_date: null,
		placement_date_alias: null,
		placement_by: null,
		owner: null,
		asset_name: null,
		asset_owner_id: null,
		status: '1',
		return_date: null,
		reason: null,
		assign_return_to: null,
		assigned_time: null,
		assign_spv_operational: null,
		assign_send_to: null,
		assign_send_date: null,
		updated_by: null,
		updated_time: null,
		description_return: null,
		description_send: null,
		asset_status: null
	},
	customer_document: {
		customer_id: null,
		name: null,
		file: null,
		document_type: null
	},
	customer_document_type: {
		name: null,
		ordering: null
	},
	product: {
		name: null,
		product_group: null,
		name_for_idm: null,
		maximum_side_heap: null,
		qty_box_each_line: null,
		status: null,
		qty_each_box: null
	},
	pricing: {
		product_id: null,
		customer_group_id: null,
		pricing_unit_id: null,
		price: null,
		fee: null
	},
	employee: {
		name: null,
		surename: null,
		username: null,
		email: null,
		start_join: null,
		end_date: null,
		mobile_phone: null,
		division_id: null,
		position_id: null,
		payment_method: null,
		bank_account_number: null,
		bank_account_name: null,
		bank_name: null,
		parent: null,
		status: null,
		authorization: null,
		address: null,
		employee_ho: null,
		id_number: null,
		religion: null,
		shift: null,
		company: null
	},
	distribution_center: {
		name: null,
		dc_code: null,
		zone: null,
		lat: null,
		lng: null,
		owner_name: null,
		address: null,
		mobile_phone: null,
		mobile_phone2: null,
		mobile_phone3: null,
		bank_account_name: null,
		bank_account_number: null,
		status: null,
		mitra: null  
	},
	distribution_center_zone: {
		dc_id: null,
		dc_code: null,
		zone: null
	},
	upload_generate_form: {
		file: null
	},
	route_non_gt: {
		route_id: null,
		customer_id: null
	},
	cro_coverage_task: {
		employee_id: null,
		related_non_gt: null,
		related_gt: null,
		related_zone: null,
		related_customer_group: null
	},
	cvo_coverage_task: {
		employee_id: null,
		related_non_gt: null,
		related_gt: null,
		related_zone: null,
		related_customer_group: null
	},
	employee_attendance: {
		employee_id: null,
		attendance_status: null,
		attendance_date: null,
		inserted_by: null,
		inserted_time: null,
		updated_by: null,
		updated_time: null,
		notes: null,
		file: null,
		path_file: null
	},
	warehouse: {
		name: null,
		prefix: null,
		related_non_gt: null,
		related_gt: null,
		address: null,
		description: null
	},
	products_history: {
		flag: null,
		product_id: null,
		income: null,
		past_qty: null,
		outcome: null,
		available: null,
		date_inserted: null
	},
	products_history_transaction: {
		products_history_id: null,
		product_id : null,
		spkb_number : null,
		order_number: null,
		date_inserted  : null,
		qty_in : null,
		qty_out : null,
		inserted_by : null,
		adjustment_by : null,
		adjustment_date: null,
		flag: null,
		flag_category: null,
		description: null
	},
	attendance_verification: {
		id: null,
		employee_id: null,
		picture: null,
		lat: null,
		lng: null,
		date_inserted: null,
		verified: null,
		verified_by: null,
		verified_time: null
	},
	mitra_coverage_survey: {
		employee_id: null,
		customer_non_gt: null,
		customer_gt: null
	},
	payment: {
		action: [],
		total_payment: [],
		total_amount: [],
		bank: null,
		payment_date: null
	},
	task_migration_cro: {
		assigned_to: null,
		assigned_prev: null
	},
	freezer_request: {
		customer_id: null,
		request_type: null,
		status: null,
		date_inserted: null,
		notes: null
	},
	bpp: {
		spkb_number: null
	},
	purchase_pricing: {
		product_id: null,
		start_date: null,
		end_date: null,
		price: null,
		flag: null
	},
	bank_of_transaction: {
		bank_of_account: null, 
		transaction_date: null,   
		description: null,
		mutation: null,
		mutation_type: null,
		total: null,
		category: null,
		transaction_type: null,
		detail_description: null,
		status: null,
		piutang_spkb_a: null,
		piutang_spkb_b: null
	},
	employee_inquiry: {
		division: null,
		position: null,
		office: null,
		reason: null,
		request_by: null,
		request_time: null,
		status: null
	},
	employee_advance: {
		title: null,
		advance_type: null,
		description: null,
		request_date: null,
		request_by: null,
		status: null,
		approved_by: null,
		approved_time: null
	},
	employee_advance_item_detail: {
		employee_advance_id: null,
		title: null,
		amount: null
	},
	employee_source_salary: {
		nik: null,
		company: null,
		salary: null
	},
	leads: {
		lead_code: null,
		name : null,
		owner_name : null,
		store_keeper : null,
		handphone : null,
		handphone2 : null,
		handphone3 : null,
		address : null,
		ktp_address : null,
		ktp_number : null,
		lat : null,
		lng : null,
		province : null,
		regencies : null,
		district : null,
		villages : null,
		selfie_employee : null,
		ktp_picture : null,
		street_store_picture : null,
		front_store_picture : null,
		right_store_picture : null,
		left_store_picture : null,
		date_inserted : null,
		inserted_by : null,
		status : null,
		description : null,
		customer_id: null
	},
	cov_visit_history: {
		id: null,
		employee_id: null,
		customer_id: null,
		before_visit: null,
		activity: null,
		after_visit: null,
		delivery_letter: null,
		description: null,
		date_inserted: null,
		flag: null
	}
}
